import { render, staticRenderFns } from "./ EquipamentCard.vue?vue&type=template&id=ec0e831e&"
import script from "./ EquipamentCard.vue?vue&type=script&lang=js&"
export * from "./ EquipamentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports